import { API_URL } from '../consts';
import {
  IFaqItemInput,
  IGetCardByCategoryIdItemInput,
  IGetCategoriesResponse,
  IGetSubmenuCategoriesResponse,
  ISearchResponse,
} from '../types';
import { IGetCardDataResponse } from '../types/api/cards';

export class CardService {
  _apiBase = `${API_URL}/api/v1`;

  async userAuth(url, user) {
    const res = await fetch(`${this._apiBase}/auth${url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ ...user }),
    });

    if (!res.ok) {
      // console.log('res', res)
      const status = res.status;
      if (status === 422) {
        throw await res.json();
      }
      //  else if (status === 401) {
      //   // throw res;
      // }
      throw res;
      // throw new Error(`Could not fetch ${url}, received ${res.status}`);
    }
    return await res.json();
  }

  async getUser(token) {
    const res = await fetch(`${this._apiBase}/profile`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`Could not fetch user, received ${res.status}`);
    }
    return await res.json();
  }

  async userRegister(user) {
    return await this.userAuth('/register', user);
  }

  async userLogin(user) {
    return await this.userAuth('/access', user);
  }

  async userLogout(user) {
    return await this.userAuth('/revoke', user);
  }

  async userUpdatePass(newpass, token) {
    const res = await fetch(`${this._apiBase}/profile/update-password`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ password: newpass }),
    });

    if (!res.ok) {
      throw new Error(`Could not fetch user, received ${res.status}`);
    }
    return await res.json();
  }

  async userForgotPass(email) {
    const res = await fetch(`${this._apiBase}/auth/forgot-password`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ email }),
    });

    if (!res.ok) {
      throw new Error(`Could not fetch user, received ${res.status}`);
    }
    return await res.json();
  }

  async contactMessage(obj) {
    const res = await fetch(`${this._apiBase}/contact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ ...obj }),
    });

    // if (!res.ok) {
    //   throw new Error(`Could not fetch user, received ${res.status}`);
    // }
    if (!res.ok) {
      // console.log('res', res)
      const status = res.status;
      if (status === 422) {
        throw await res.json();
      }
      //  else if (status === 401) {
      //   // throw res;
      // }
      throw res;
      // throw new Error(`Could not fetch ${url}, received ${res.status}`);
    }
    return await res.json();
  }

  async getResource(url: string, options?: { signal?: AbortSignal }) {
    const res = await fetch(`${this._apiBase}/data${url}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      signal: options?.signal,
    });

    if (!res.ok) {
      throw new Error(`Could not fetch ${url}, received ${res.status}`);
    }
    return await res.json();
  }

  async getCategoryList(): Promise<IGetCategoriesResponse> {
    return await this.getResource('/categories');
  }

  // Deprecated
  async getCategoryListHome() {
    return await this.getResource('/categories-home');
  }

  // Deprecated
  async getCategoryItem(slug) {
    return await this.getResource(`/categories/${slug}`);
  }

  // Deprecated
  async getTagList() {
    return await this.getResource('/tags');
  }

  async getCard(id: string): Promise<IGetCardDataResponse> {
    return await this.getResource(`/cards/${id}`);
  }

  async getCardsByCategory(category: string) {
    return await this.getResource(`/categories/cards/${category}`);
  }

  async getCardsByCategoryId(
    id: number,
    options?: { signal?: AbortSignal }
  ): Promise<IGetCardByCategoryIdItemInput[]> {
    return await this.getResource(`/categories/cards/category/${id}`, options);
  }

  // Deprecated
  async getCardsByTag(category, tag) {
    return await this.getResource(`/tags/cards/${category}/${tag}`);
  }

  // Deprecated
  async getBanners() {
    return await this.getResource('/banners');
  }

  // async setDraft(card) {
  //   const res = await fetch(`${this._apiBase}/orders/save-draft`, {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       Accept: 'application/json',
  //     },
  //     body: JSON.stringify({ ...card }),
  //   });

  //   if (!res.ok) {
  //     // console.log('res', res)
  //     const status = res.status;
  //     if (status === 422) {
  //       throw await res.json();
  //     }
  //     throw res;
  //     // throw new Error(`Could not fetch ${url}, received ${res.status}`);
  //   }
  //   return await res.json();
  // }

  // Deprecated
  async getDraft(key) {
    const res = await fetch(`${this._apiBase}/orders/draft/${key}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });

    if (!res.ok) {
      // console.log('res', res)
      const status = res.status;
      if (status === 422) {
        throw await res.json();
      }
      throw res;
      // throw new Error(`Could not fetch ${url}, received ${res.status}`);
    }
    return await res.json();
  }

  async getMenu() {
    return await this.getResource('/menu');
  }

  async getMainMenu() {
    return await this.getResource('/main-menu');
  }

  async getSubmenuCategories(options?: {
    signal?: AbortSignal;
  }): Promise<IGetSubmenuCategoriesResponse> {
    return await this.getResource('/submenu-categories', options);
  }

  async getChatySettings() {
    const res = await fetch(`${this._apiBase}/data/chaty`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });

    if (!res.ok) {
      throw new Error(`Could not fetch Chaty settings, received ${res.status}`);
    }
    return await res.json();
  }

  async getBestSellers(categoryId) {
    const res = await fetch(`${this._apiBase}/data/best-sellers/${categoryId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });

    if (!res.ok) {
      throw new Error(`Could not fetch Best sellers, received ${res.status}`);
    }
    return await res.json();
  }

  // helpers
  formsErrorHandler(err) {
    const newFormErrors = {};
    const fieldNames: any[] = [];
    err.errors.map((item) => {
      if (!fieldNames.includes(item.field)) {
        newFormErrors[item.field] = item.message;
        if (item.rule === 'minLength' && item.args && item.args.minLength) {
          newFormErrors[item.field] = `min length: ${item.args.minLength}`;
        }
        fieldNames.push(item.field);
      }
      return item;
    });
    // console.log('newFormErrors', newFormErrors);
    return newFormErrors;
  }

  // Deprecated
  async getFooterMenu() {
    return await this.getResource('/footer-links');
  }

  async getVideo() {
    return await this.getResource('/how-it-works-media');
  }

  // Deprecated
  async getNewCards() {
    return await this.getResource('/new-design-cards');
  }

  async getFAQ(): Promise<IFaqItemInput[]> {
    return await this.getResource('/frequently-asked-questions');
  }

  async getIcon(url) {
    const res = await fetch(url);
    if (res) {
      return await res.text();
    }
  }

  async getVideoAvailability() {
    return await this.getResource('/video-availability');
  }

  async getSectionAvailability() {
    return await this.getResource('/section-availability');
  }

  // Deprecated
  async getVideoStatusButton() {
    return await this.getResource('/video-status-button');
  }

  async getSearchResults(query: string): Promise<ISearchResponse> {
    return await this.getResource(`/search?query=${query}`);
  }
}
